import React, { useState, useEffect, useContext } from "react";
import { motion, AnimatePresence } from "motion/react";
import styles from "./GoldenchitPage.module.css";
import { LanguageContext } from "./LanguageContext";
import { useNavigate } from "react-router-dom";
import {insertGoldenRewardApi} from "../http/http";
import Cookies from "js-cookie";
import { GOLDEN, pageT } from "../utils/i18n";
const PRIZES = ["500 points", "500MB", "800MB", "10GB", "1GB"];

const GoldenchitPage = () => {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t = pageT(lang, GOLDEN);
  const [step, setStep] = useState("envelope");
  const [prize, setPrize] = useState(null);


     useEffect(() => {
            const token = Cookies.get("token");
            if (!token)  navigate("/");
        
          }, []);

  const handleEnvelopeClick = () => {
    if (step === "envelope") {
      setStep("opening_envelope");
      setTimeout(() => {
        setStep("gift");
      }, 1000);
    }
  };

  const formatPrizeForApi = (prize) => {
  if (!prize) return null;

  if (prize.toLowerCase().includes("points")) {
  
    return Number(prize.replace(/\D/g, ""));
  }

  return prize;
};


 const handleGiftClick = async () => {
  const randomPrize = PRIZES[Math.floor(Math.random() * PRIZES.length)];
  setPrize(randomPrize);
  setStep("opening_gift");

  const formattedPrize = formatPrizeForApi(randomPrize);

  try {
    const token = Cookies.get("token");
    console.log(token,"--------")
    await insertGoldenRewardApi({
      token, 
      reward: formattedPrize,
    });

    console.log("Reward saved successfully");
  } catch (error) {
    console.error("Error saving reward", error);
  }

  setTimeout(() => {
    setStep("prize");
  }, 2000);
};


  const showBox = step !== "prize_overlay";

  return (
    <div className={styles.container}>

      <div className={styles.floatingChitsContainer}>
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className={styles.floatingChit}
            style={{
              left: `${Math.random() * 100}%`,
              animationDuration: `${10 + Math.random() * 20}s`,
              animationDelay: `${Math.random() * 5}s`,
              transform: `scale(${0.5 + Math.random() * 0.5})`
            }}
          />
        ))}
      </div>

      <AnimatePresence mode="wait">


        {(step === "envelope" || step === "opening_envelope" || step === "gift" || step === "opening_gift" || step === "prize") && (
          <motion.div
            key="envelope-group"
            className={styles.envelopeContainer}
            onClick={handleEnvelopeClick}
            initial={{ scale: 0, rotate: -10 }}
            animate={{ scale: 1, rotate: 0 }}
            exit={{ scale: 0, opacity: 0, transition: { duration: 0.5 } }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
          >

            <motion.div
              className={styles.envelopeFlap}
              animate={
                step === "opening_envelope" || step === "gift" || step === "opening_gift" || step === "prize"
                  ? { rotateX: 180, zIndex: 1, opacity: showBox ? 1 : 0 }
                  : { rotateX: 0, zIndex: 30, opacity: showBox ? 1 : 0 }
              }
              transition={{ duration: 0.6 }}
            />


            <motion.div
              className={styles.envelopeBase}
              animate={{ opacity: showBox ? 1 : 0 }}
            />


            {(step === "gift" || step === "opening_gift" || step === "prize") && (
              <motion.div
                className={styles.giftBoxContainer}
                initial={{ y: 50,x:-50, scale: 0.5, opacity: 0 }}
                animate={{
                  y: (step === "opening_gift" || step === "prize") ? -150 : -120,
                  scale: (step === "opening_gift" || step === "prize") ? 1.5 : 1,
                  opacity: 1,
                }}
                transition={{ duration: 0.9, ease: "backOut" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleGiftClick();
                }}
                whileHover={{ scale: 1.1 }}
                style={{ cursor: "pointer" }}
              >
                <motion.div
                  className={styles.gift3D}
                  animate={(step === "opening_gift" || step === "prize") ? { rotateX: 0, rotateY: 0 } : { rotateX: -20, rotateY: 300 }}
                  transition={{ duration: 1.5 }}
                >

                  <motion.div
                    className={`${styles.giftSide} ${styles.sideFront}`}
                    style={{ backfaceVisibility: 'visible' }}
                    animate={{ opacity: showBox ? 1 : 0 }}
                    transition={{ duration: 1 }}
                  >
                    <div className={styles.ribbonVertical}></div>
                    <div className={styles.ribbonHorizontal}></div>
                  </motion.div>

               
                  <motion.div
                    className={`${styles.giftSide} ${styles.sideBack}`}
                    style={{ backfaceVisibility: 'visible' }}
                    animate={{ opacity: showBox ? 1 : 0 }}
                    transition={{ duration: 1 }}
                  >
                    <div className={styles.ribbonVertical}></div>
                    <div className={styles.ribbonHorizontal}></div>
                  </motion.div>

                  <motion.div
                    className={`${styles.giftSide} ${styles.sideLeft}`}
                    style={{ backfaceVisibility: 'visible' }}
                    animate={{ opacity: showBox ? 1 : 0 }}
                    transition={{ duration: 1 }}
                  >
                    <div className={styles.ribbonVertical}></div>
                    <div className={styles.ribbonHorizontal}></div>
                  </motion.div>

                
                  <motion.div
                    className={`${styles.giftSide} ${styles.sideRight}`}
                    style={{ backfaceVisibility: 'visible' }}
                    animate={{ opacity: showBox ? 1 : 0 }}
                    transition={{ duration: 1 }}
                  >
                    <div className={styles.ribbonVertical}></div>
                    <div className={styles.ribbonHorizontal}></div>
                  </motion.div>

                  <div className={`${styles.face} ${styles.faceBottom}`} style={{ opacity: showBox ? 1 : 0 }}></div>


                  <motion.div
                    className={styles.lidGroup}
                    animate={(step === "opening_gift" || step === "prize") ? {
                      y: -120, 
                      rotateX: 60,
                      opacity: 1 
                    } : { y: 0, rotateX: 0, opacity: 1 }}
                    transition={{ duration: 1.2, ease: "easeInOut" }}
                  >
                    <div className={styles.lidTop}>
                      <div className={styles.lidRibbonVertical}></div>
                      <div className={styles.lidRibbonHorizontal}></div>
                      <div className={styles.bow}></div>
                    </div>
                    <div className={`${styles.lidFace} ${styles.lidFront}`}></div>
                    <div className={`${styles.lidFace} ${styles.lidBack}`}></div>
                    <div className={`${styles.lidFace} ${styles.lidRight}`}></div>
                    <div className={`${styles.lidFace} ${styles.lidLeft}`}></div>
                  </motion.div>


                
                  <motion.div
                    className={styles.risingPrize}
                    initial={{ scale: 0.1, y: 30, z: 0, opacity: 0 }}
                    animate={step === "prize" ? {
                      scale: 0.5,
                      y: -150, 
                      z: 100, 
                      x:-180,
                      opacity: 1
                    } : { scale: 0.1, y: -250, x:-180, z: 0, opacity: 0 }}
                    transition={{
                      duration: 1.5,
                      ease: "easeOut", 
                      delay: 0.2
                    }}
                    style={{ pointerEvents: "auto", width: 'auto', height: 'auto' }}
                  >
                    <motion.div
                      className={styles.prizeContainer}
                      style={{ position: 'relative', transform: 'none', background: 'black' }}
                    >
                      <motion.div
                        animate={{
                          scale: [1, 1.2, 1],
                          rotate: [0, 5, -5, 0],
                          filter: ["brightness(1)", "brightness(1.3)", "brightness(1)"]
                        }}
                        transition={{ repeat: Infinity, duration: 2 }}
                      >
                        <div style={{ fontSize: "4rem" }}>🌟</div>
                      </motion.div>

                      <h2 className={styles.prizeTitle}>{t.congrats}</h2>
                      <div className={styles.prizeValue}>{prize}</div>

                      <motion.button
                        className={styles.actionButton}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={() => navigate("/home")}
                      >
                        {t.claimPrize}
                      </motion.button>
                    </motion.div>
                  </motion.div>
                </motion.div>
              </motion.div>
            )}


            <motion.div className={styles.envelopePocket} animate={{ opacity: showBox ? 1 : 0 }} />
          </motion.div>
        )}

      </AnimatePresence>
    </div>
  );
};

export default GoldenchitPage;
